import "bootstrap/dist/css/bootstrap.css";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NotFound from "./pages/NotFound";
import AuthLayout from "./layouts/AuthLayout";
import "./assets/styles/scss/main.scss";
import Login from "./pages/Login";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyMail from "./pages/VerifyMail";
import Settings from "./pages/Settings";
import DashboardLayout from "./layouts/DashboardLayout";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/Dashboard";
import "react-quill/dist/quill.snow.css";
import "react-tooltip/dist/react-tooltip.css";
// import { useContext } from "react";
// import { Context } from "./context/MainContext";
import Gallery from "./pages/Gallery";
import AddGallery from "./pages/AddGallery";
import Blog from "./pages/Blog";
import AddBlog from "./pages/AddBlog";
import EditBlog from "./pages/EditBlog";
import ProductsDB from "./pages/ProductsDB";
import AddProduct from "./pages/AddProduct";
import EditProduct from "./pages/EditProduct";
import OrdersDB from "./pages/OrdersDB";
import OrderItemDB from "./pages/OrderItemDB";
import Training from "./pages/Training";
// import EditGallery from "./pages/EditGallery";

function App() {
  // const { user } = useContext(Context);
  // const navigate = useNavigate();

  return (
    <div className="App">
      <ToastContainer position="top-right" />
      <Router>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<AuthLayout />}>
            <Route index element={<Login />} />
            <Route path="login" element={<Login />} />
            {/* <Route path="signup" element={<Signup />} /> */}
            <Route path="forgot-password" element={<ForgetPassword />} />
            <Route path="verify-mail/:id" element={<VerifyMail />} />
            <Route path="reset-password/:id" element={<ResetPassword />} />
          </Route>

          <Route path="/dashboard" element={<DashboardLayout />}>
            {/* <Route index element={<StaffDashboard />} /> */}
            <Route index element={<Dashboard />} />
            <Route path="settings" element={<Settings />} />

            <Route path="products" element={<ProductsDB />} />
            <Route path="products/add" element={<AddProduct />} />
            <Route path="products/edit/:id" element={<EditProduct />} />

            <Route path="orders" element={<OrdersDB />} />
            <Route path="orders/:id" element={<OrderItemDB />} />
            {/* <Route path="events/add" element={<AddEvent />} />
            <Route path="events/edit/:id" element={<EditEvent />} /> */}

            <Route path="training" element={<Training />} />
            {/* <Route path="adverts/add" element={<AddAdvert />} />
            <Route path="adverts/edit/:id" element={<EditAdvert />} /> */}

            <Route path="gallery" element={<Gallery />} />
            <Route path="gallery/add" element={<AddGallery />} />
            {/* <Route path="gallery/edit/:id" element={<EditGallery />} /> */}

            <Route path="blogs" element={<Blog />} />
            <Route path="blogs/add" element={<AddBlog />} />
            <Route path="blogs/edit/:id" element={<EditBlog />} />

            {/* <Route path="directory" element={<Directory />} />
            <Route path="directory/add" element={<AddDirectory />} />
            <Route path="directory/edit/:id" element={<EditDirectory />} />

            <Route path="interviews" element={<Interview />} />
            <Route path="interviews/add" element={<AddInterview />} />
            <Route path="interviews/edit/:id" element={<EditInterview />} /> */}
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
